<template>
    <el-container class="mc-page" style="flex-direction: column;">
        <el-header>
            <div class="menu">
                <div class="logo">
<!--                    <img src="../../static/image/logo.png">-->
                    <span style="color: #fb6638;font-size: 22px;font-weight: 600;">万家优货</span>
                </div>
                <div class="user" v-if="account != ''">

                    <el-dropdown style="float: right">
                        <div class="el-dropdown-link user-info" style="line-height: 64px;font-size: 12px;cursor: pointer">
                            {{account}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </div>
                        <el-dropdown-menu slot="dropdown" class="user-dropdown">
                            <el-dropdown-item class="user-dropdown-item">
                                <a href="#/account/password" class="handle">
                                    <i class="iconfont icon-xiugaimima"></i>修改密码
                                </a>
                            </el-dropdown-item>
                            <el-dropdown-item class="user-dropdown-item">
                                <div class="handle" @click="logout">
                                    <i class="iconfont icon-tuichu"></i>
                                    退出登录
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </el-header>
        <el-main class="flex1" style="overflow: auto;">
            <div class="mc-body">
                <slot></slot>
            </div>
            <div class="footer mc-footer">
                <div class="footer-body">
                    <p style="text-align: center;">技术支持 © 南京狸先生信息技术有限公司</p>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
    import axios from 'axios';
    axios.defaults.withCredentials = true;
    export default {
        name: "account-common",
        data () {
            return {
                account: this.$store.state.account
            }
        },
        methods: {
            logout(){
                const self = this;
                axios.get(window.settings.api_url + 'index/account/logout').then(function(response){
                    var data = response.data;
                    if (data.error == 0){
                        self.$router.push("/account/login");
                    }else{
                        self.$message.error(data.result.message);
                    }
                })
            }
        }
    }
</script>

<style scoped>
    @import "common.css";
</style>